import React from 'react'
import {
  Grid,
  Typography,
} from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart';
import { useSelector } from 'react-redux'
import { getClinvarVizData } from './utilities.js';

function DataViz(){

  const clinicalSignificance = useSelector((state) => state.clinvarData.clinicalSignificance)
  const data = useSelector((state) => state.clinvarData.data)

  const clinvarVizData = getClinvarVizData(data)
  let dataX, dataY, chromLabel
  if (data.length) {
    if (clinvarVizData['13']) {
      // If we can, we display data relating to chrom = 13:
      chromLabel = '13'
      dataX = clinvarVizData['13'].barData.map(item => item.label)
      dataY = clinvarVizData['13'].barData.map(item => item.count)
    } else {
      // ... otherwise, we display the first chrom data we have:
      chromLabel = Object.keys(clinvarVizData)[0]
      dataX = clinvarVizData[Object.keys(clinvarVizData)[0]].barData.map(item => item.label)
      dataY = clinvarVizData[Object.keys(clinvarVizData)[0]].barData.map(item => item.count)
    }
  }

  if (data.length) {
    return (
      <Grid container sx={{ ml: 5, display: 'flex', flexDirection: 'column' }}>
        <Grid item md={12} sx={{ mb: 3 }}>
          <Typography variant='h4'>Visualization</Typography>
        </Grid>
        <Grid item md={12} sx={{ mb: 3, pt: 1 }}>
          <Typography variant='body1'>Number of variants with <b>Clinical Significance = {clinicalSignificance.replace('_', ' ')}</b> in
          each <b>pos</b> range for <b>chrom = { chromLabel }</b></Typography>
        </Grid>
        <Grid
          container
          sx={{ display: 'flex', flexDirection: 'column' }}
          rowSpacing={2}
        >
          <Grid item sx={{ width: '100%', height:'40vh' }}>
            <BarChart
              xAxis={[
                {
                  id: 'barCategories',
                  data: dataX,
                  scaleType: 'band',
                },
              ]}
              series={[
                {
                  data: dataY,
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid item md={12} sx={{ mb: 3, pt: 1 }}>
          <Typography variant='body1'>
            <b>NOTES:</b> <br />
            - If the data has been filtered, then the chart above will stay static as you page through the data. <br />
            - Data for chrom 13 is displayed by default if present, otherwise data for the first chrom in the list.
          </Typography>
        </Grid>
      </Grid>
    )
  } else {
    return null
  }
}

export default DataViz
